// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Ftypes-core%2Fsrc%2Foperations.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------

import { IAddOperation, IDeleteOperation, IDeltaUpdateOperation, IFocusOperation, IItemChangesDelta, IItemDelta, IMicroSyncOperation, IMoveOperation, IOperation, IOperationWithSiblingContext, IPurgeOperation, ISignalOperation, IUpdateAnnotationMetaDataOperation, IUpdateOperation, IVisibilityOperation, Item, ItemChanges, ItemPath } from '../operations';
import { SchemaObject } from './schema-object.g';
import { ISchemaObject, SchemaObjectHeader } from '../schema-object';
import { AnnotationMetaData } from '../annotations';

export class ItemDelta implements IItemDelta {
    public readonly state?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IItemDelta) {
        SchemaObject.assign(ItemDelta, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_ItemDelta';
    }
    public static getBaseTypes(): string[] {
        return [];
    }
    public static readonly H_ = { T_: ItemDelta.getTypeName(), B_: ItemDelta.getBaseTypes() };
    /**
     * Checks if passed schema object is of ItemDelta type or its inheritor and implements {@link IItemDelta}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IItemDelta {
        return SchemaObject.matchesTypesFor(schemaObject, [ItemDelta.getTypeName()]);
    }
}

export class ItemChangesDelta implements IItemChangesDelta {
    public changes: ItemChanges[];
    public readonly state?: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IItemChangesDelta) {
        SchemaObject.assign(ItemChangesDelta, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_ItemChangesDelta';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_ItemDelta'];
    }
    public static readonly H_ = { T_: ItemChangesDelta.getTypeName(), B_: ItemChangesDelta.getBaseTypes() };
    /**
     * Checks if passed schema object is of ItemChangesDelta type or its inheritor and implements {@link IItemChangesDelta}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IItemChangesDelta {
        return SchemaObject.matchesTypesFor(schemaObject, [ItemChangesDelta.getTypeName()]);
    }
}

export class Operation implements IOperation {
    public parentPath: ItemPath;
    public parentRevId?: string;
    public items: Item[];
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IOperation) {
        SchemaObject.assign(Operation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_Operation';
    }
    public static getBaseTypes(): string[] {
        return [];
    }
    public static readonly H_ = { T_: Operation.getTypeName(), B_: Operation.getBaseTypes() };
    /**
     * Checks if passed schema object is of Operation type or its inheritor and implements {@link IOperation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IOperation {
        return SchemaObject.matchesTypesFor(schemaObject, [Operation.getTypeName()]);
    }
}

export class OperationWithSiblingContext implements IOperationWithSiblingContext {
    public prevId?: string;
    public nextId?: string;
    public parentPath: ItemPath;
    public parentRevId?: string;
    public items: Item[];
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IOperationWithSiblingContext) {
        SchemaObject.assign(OperationWithSiblingContext, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_OperationWithSiblingContext';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Operation'];
    }
    public static readonly H_ = { T_: OperationWithSiblingContext.getTypeName(), B_: OperationWithSiblingContext.getBaseTypes() };
    /**
     * Checks if passed schema object is of OperationWithSiblingContext type or its inheritor and implements {@link IOperationWithSiblingContext}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IOperationWithSiblingContext {
        return SchemaObject.matchesTypesFor(schemaObject, [OperationWithSiblingContext.getTypeName()]);
    }
}

export class AddOperation implements IAddOperation {
    public prevId?: string;
    public nextId?: string;
    public parentPath: ItemPath;
    public parentRevId?: string;
    public items: Item[];
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IAddOperation) {
        SchemaObject.assign(AddOperation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_AddOperation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_OperationWithSiblingContext', 'AugLoop_Core_Operation'];
    }
    public static readonly H_ = { T_: AddOperation.getTypeName(), B_: AddOperation.getBaseTypes() };
    /**
     * Checks if passed schema object is of AddOperation type or its inheritor and implements {@link IAddOperation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IAddOperation {
        return SchemaObject.matchesTypesFor(schemaObject, [AddOperation.getTypeName()]);
    }
}

export class MoveOperation implements IMoveOperation {
    public prevParentPath: ItemPath;
    public prevId?: string;
    public nextId?: string;
    public parentPath: ItemPath;
    public parentRevId?: string;
    public items: Item[];
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IMoveOperation) {
        SchemaObject.assign(MoveOperation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_MoveOperation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_OperationWithSiblingContext', 'AugLoop_Core_Operation'];
    }
    public static readonly H_ = { T_: MoveOperation.getTypeName(), B_: MoveOperation.getBaseTypes() };
    /**
     * Checks if passed schema object is of MoveOperation type or its inheritor and implements {@link IMoveOperation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IMoveOperation {
        return SchemaObject.matchesTypesFor(schemaObject, [MoveOperation.getTypeName()]);
    }
}

export class UpdateAnnotationMetaDataOperation implements IUpdateAnnotationMetaDataOperation {
    public M_: AnnotationMetaData;
    public parentPath: ItemPath;
    public parentRevId?: string;
    public items: Item[];
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IUpdateAnnotationMetaDataOperation) {
        SchemaObject.assign(UpdateAnnotationMetaDataOperation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_UpdateAnnotationMetaDataOperation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Operation'];
    }
    public static readonly H_ = { T_: UpdateAnnotationMetaDataOperation.getTypeName(), B_: UpdateAnnotationMetaDataOperation.getBaseTypes() };
    /**
     * Checks if passed schema object is of UpdateAnnotationMetaDataOperation type or its inheritor and implements {@link IUpdateAnnotationMetaDataOperation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IUpdateAnnotationMetaDataOperation {
        return SchemaObject.matchesTypesFor(schemaObject, [UpdateAnnotationMetaDataOperation.getTypeName()]);
    }
}

export class UpdateOperation implements IUpdateOperation {
    public parentPath: ItemPath;
    public parentRevId?: string;
    public items: Item[];
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IUpdateOperation) {
        SchemaObject.assign(UpdateOperation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_UpdateOperation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Operation'];
    }
    public static readonly H_ = { T_: UpdateOperation.getTypeName(), B_: UpdateOperation.getBaseTypes() };
    /**
     * Checks if passed schema object is of UpdateOperation type or its inheritor and implements {@link IUpdateOperation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IUpdateOperation {
        return SchemaObject.matchesTypesFor(schemaObject, [UpdateOperation.getTypeName()]);
    }
}

export class DeleteOperation implements IDeleteOperation {
    public parentPath: ItemPath;
    public parentRevId?: string;
    public items: Item[];
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IDeleteOperation) {
        SchemaObject.assign(DeleteOperation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_DeleteOperation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Operation'];
    }
    public static readonly H_ = { T_: DeleteOperation.getTypeName(), B_: DeleteOperation.getBaseTypes() };
    /**
     * Checks if passed schema object is of DeleteOperation type or its inheritor and implements {@link IDeleteOperation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IDeleteOperation {
        return SchemaObject.matchesTypesFor(schemaObject, [DeleteOperation.getTypeName()]);
    }
}

export class PurgeOperation implements IPurgeOperation {
    public parentPath: ItemPath;
    public parentRevId?: string;
    public items: Item[];
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IPurgeOperation) {
        SchemaObject.assign(PurgeOperation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_PurgeOperation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Operation'];
    }
    public static readonly H_ = { T_: PurgeOperation.getTypeName(), B_: PurgeOperation.getBaseTypes() };
    /**
     * Checks if passed schema object is of PurgeOperation type or its inheritor and implements {@link IPurgeOperation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IPurgeOperation {
        return SchemaObject.matchesTypesFor(schemaObject, [PurgeOperation.getTypeName()]);
    }
}

export class FocusOperation implements IFocusOperation {
    public isFocused: boolean;
    public parentPath: ItemPath;
    public parentRevId?: string;
    public items: Item[];
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IFocusOperation) {
        SchemaObject.assign(FocusOperation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_FocusOperation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Operation'];
    }
    public static readonly H_ = { T_: FocusOperation.getTypeName(), B_: FocusOperation.getBaseTypes() };
    /**
     * Checks if passed schema object is of FocusOperation type or its inheritor and implements {@link IFocusOperation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IFocusOperation {
        return SchemaObject.matchesTypesFor(schemaObject, [FocusOperation.getTypeName()]);
    }
}

export class VisibilityOperation implements IVisibilityOperation {
    public isVisible: boolean;
    public parentPath: ItemPath;
    public parentRevId?: string;
    public items: Item[];
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IVisibilityOperation) {
        SchemaObject.assign(VisibilityOperation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_VisibilityOperation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Operation'];
    }
    public static readonly H_ = { T_: VisibilityOperation.getTypeName(), B_: VisibilityOperation.getBaseTypes() };
    /**
     * Checks if passed schema object is of VisibilityOperation type or its inheritor and implements {@link IVisibilityOperation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IVisibilityOperation {
        return SchemaObject.matchesTypesFor(schemaObject, [VisibilityOperation.getTypeName()]);
    }
}

export class DeltaUpdateOperation implements IDeltaUpdateOperation {
    public parentPath: ItemPath;
    public parentRevId?: string;
    public items: Item[];
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IDeltaUpdateOperation) {
        SchemaObject.assign(DeltaUpdateOperation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_DeltaUpdateOperation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Operation'];
    }
    public static readonly H_ = { T_: DeltaUpdateOperation.getTypeName(), B_: DeltaUpdateOperation.getBaseTypes() };
    /**
     * Checks if passed schema object is of DeltaUpdateOperation type or its inheritor and implements {@link IDeltaUpdateOperation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IDeltaUpdateOperation {
        return SchemaObject.matchesTypesFor(schemaObject, [DeltaUpdateOperation.getTypeName()]);
    }
}

export class MicroSyncOperation implements IMicroSyncOperation {
    public readonly seq?: number;
    public readonly opType?: string;
    public parentPath: ItemPath;
    public parentRevId?: string;
    public items: Item[];
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IMicroSyncOperation) {
        SchemaObject.assign(MicroSyncOperation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_MicroSyncOperation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Operation'];
    }
    public static readonly H_ = { T_: MicroSyncOperation.getTypeName(), B_: MicroSyncOperation.getBaseTypes() };
    /**
     * Checks if passed schema object is of MicroSyncOperation type or its inheritor and implements {@link IMicroSyncOperation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IMicroSyncOperation {
        return SchemaObject.matchesTypesFor(schemaObject, [MicroSyncOperation.getTypeName()]);
    }
}

export class SignalOperation implements ISignalOperation {
    public parentPath: ItemPath;
    public parentRevId?: string;
    public items: Item[];
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ISignalOperation) {
        SchemaObject.assign(SignalOperation, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Signals_SignalOperation';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Operation'];
    }
    public static readonly H_ = { T_: SignalOperation.getTypeName(), B_: SignalOperation.getBaseTypes() };
    /**
     * Checks if passed schema object is of SignalOperation type or its inheritor and implements {@link ISignalOperation}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is ISignalOperation {
        return SchemaObject.matchesTypesFor(schemaObject, [SignalOperation.getTypeName()]);
    }
}

